/* eslint-disable no-unused-vars */
import {
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Box,
	Button,
	Card,
	CardContent,
	FormControl,
	InputLabel,
	IconButton,
	MenuItem,
	Select,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TextField,
	useMediaQuery,
	FormControlLabel,
	Link,
	Checkbox,
	Typography,
	CircularProgress,
	Alert,
	Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useCart } from "../../context/cartContext";
import { useSite } from "../../context/siteContext";
import { useAuth } from "../../context/authContext";
import customHttp from "../../services/customHTTP";
import { useNavigate } from "react-router-dom";
import PageTitle from "../../components/PageTitle/PageTitle";
import { styled } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditIcon from "@mui/icons-material/Edit";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Swal from "sweetalert2";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DefaultLoader from "../../components/DefaultLoader/DefaultLoader";
import { ASSETS_BASE_URL } from "../../config";
import HelpIcon from "@mui/icons-material/Help";

const Checkout = () => {
	const { user } = useAuth();
	const { cartItems, clearCart } = useCart();
	const { selectedSite, selectedSiteData, siteData, selectedSiteCurrency, currencySymbol } = useSite();
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [selectedCustomer, setSelectedCustomer] = useState(null);
	const [buttonLoading, setButtonLoading] = useState(false);
	const [buttonSuccess, setButtonSuccess] = useState(false);
	const [cartProducts, setCartProducts] = useState([]);
	const [isInitialized, setIsInitialized] = useState(false);
	const [termsAccepted, setTermsAccepted] = useState(false);
	const [messageShow, setMessageShow] = useState(false);
	const [uploadedFile, setUploadedFile] = useState([]);
	const [expandedPanels, setExpandedPanels] = useState({
		panel1: true,
		panel2: true,
		panel3: true,
	});

	const [isEditing, setIsEditing] = useState({
		shipping: false,
		billing: false,
	});

	const [errors, setErrors] = useState({});
	const isMobile = useMediaQuery("(max-width:600px)");

	console.log(selectedSiteData);

	const [checkoutDetails, setCheckoutDetails] = useState({
		shipping_address: {
			name: ``,
			street: `${selectedSiteData.street1_ln} ${selectedSiteData.street2_ln} ${selectedSiteData.street3_ln}`,
			city: `${selectedSiteData.city_ln}`,
			zip: `${selectedSiteData.zip_ln}`,
			country: `${selectedSiteData.country_ln}`,
			state: `${selectedSiteData.state_ln}`,
		},
		billing_address: {
			name: "",
			street: "",
			city: "",
			zip: "",
			country: "",
			state: "",
		},
		additional_details: {
			delivery_terms: "Prepaid and Add",
			ship_complete: "No",
			mode_of_delivery: "UPS Ground",
			frieght_number: "",
			order_notes: "",
		},
		payment_details: {
			payment_mode: "PO",
			payment_details: {
				po_number: "",
				po_file: "",
			},
		},
		order_details: {
			products: [
				{
					product_id: "",
					ProductQty: "",
					ProductPrice: "",
					total: "",
				},
			],
			taxes: "",
			shipping: "",
			discounts: "",
			total: "",
			currency: selectedSiteCurrency || "usd",
		},
	});

	const navigate = useNavigate();

	const VisuallyHiddenInput = styled("input")({
		clip: "rect(0 0 0 0)",
		clipPath: "inset(50%)",
		height: 1,
		overflow: "hidden",
		position: "absolute",
		bottom: 0,
		left: 0,
		whiteSpace: "nowrap",
		width: 1,
	});

	useEffect(() => {
		const fetchCustomerData = async () => {
			try {
				const customer_resp = await customHttp.get(`/cus_sites/getcustomer/${selectedSiteData.cus_id}`);
				console.log(customer_resp);
				setSelectedCustomer(customer_resp.data.data);
				setCheckoutDetails({
					...checkoutDetails,
					billing_address: {
						name: `${customer_resp.data.data.address_name_cus}`,
						street: `${customer_resp.data.data.street1_cus} ${customer_resp.data.data.street2_cus} ${customer_resp.data.data.street3_cus}`,
						city: `${customer_resp.data.data.city_cus}`,
						zip: `${customer_resp.data.data.zip_cus}`,
						country: `${customer_resp.data.data.country_cus}`,
						state: `${customer_resp.data.data.state_cus}`,
					},
					shipping_address: {
						name: `${selectedSiteData.address_name_ln} - ${selectedSiteData.customer_site_number}`,
						street: `${selectedSiteData.street1_ln} ${selectedSiteData.street2_ln} ${selectedSiteData.street3_ln}`,
						city: `${selectedSiteData.city_ln}`,
						zip: `${selectedSiteData.zip_ln}`,
						country: `${selectedSiteData.country_ln}`,
						state: `${selectedSiteData.state_ln}`,
					},
				});
			} catch (error) {
				console.log(error);
			}
		};

		// if (selectedSite) {
		fetchCustomerData();
		// }
	}, [selectedSiteData]);

	const handleInputChange = (section, field, value) => {
		setCheckoutDetails((prev) => ({
			...prev,
			[section]: {
				...prev[section],
				[field]: value,
			},
		}));
	};

	const handleAccordionChange = (panel) => (event, isExpanded) => {
		setExpandedPanels((prev) => ({
			...prev,
			[panel]: isExpanded,
		}));
	};

	const handleCheckboxChange = (event) => {
		setTermsAccepted(event.target.checked);
	};

	const handleFileUpload = (event) => {
		const file = event.target.files[0];
		if (file) {
			// handleFieldChange("payment_details", "payment_details.po_number", file.name);
			setUploadedFile(file.name); // Store the uploaded file name
		}
	};

	const getLeadDate = (product) => {
		var lead_days = product.product_sell_end_date;
		lead_days = parseInt(lead_days, 10);

		let ctp;
		if (isNaN(lead_days)) {
			ctp = "To Be Decided";
		} else {
			const today = new Date();
			today.setDate(today.getDate() + lead_days); // Add lead_days to today's date
			ctp = today.toISOString().split("T")[0]; // Format as YYYY-MM-DD
		}
		return ctp;
	};

	useEffect(() => {
		const fetchProducts = async () => {
			setLoading(true);
			setError(null);

			const filteredCartItems = cartItems.filter((item) => item.Site === selectedSite);

			if (filteredCartItems.length === 0) {
				setCartProducts([]);
				setLoading(false);
				setIsInitialized(true);
				return;
			}

			try {
				const reqBody = {
					products: [
						...new Set(
							filteredCartItems
								.filter((item) => item.ProductID && item.ProductID !== "" && item.Site === selectedSite)
								.map((item) => item.ProductID)
						),
					],
				};

				const response = await customHttp.post("/products/byids", reqBody);
				const productData = response.data?.data || [];

				const updatedCartItems = await Promise.all(
					filteredCartItems.map(async (item) => {
						const matchedProduct = productData.find((product) => product.product_id === item.ProductID);
						if (matchedProduct) {
							return {
								...item,
								Product: matchedProduct,
							};
						}
						return item;
					})
				);

				setCartProducts(updatedCartItems);
			} catch (err) {
				setError("Failed to fetch data: " + err.message);
			} finally {
				setLoading(false);
				setIsInitialized(true);
			}
		};

		if (cartItems.length > 0) {
			fetchProducts();
		} else {
			setCartProducts([]);
			setLoading(false);
			setIsInitialized(true);
		}
	}, [selectedSite, cartItems]);

	const validateAddress = (address, fieldPrefix) => {
		const newErrors = {};

		if (!address.name) newErrors[`${fieldPrefix}.name`] = "Name is required";
		if (!address.street) newErrors[`${fieldPrefix}.street`] = "Street is required";
		if (!address.city) newErrors[`${fieldPrefix}.city`] = "City is required";
		if (!address.zip) newErrors[`${fieldPrefix}.zip`] = "ZIP code is required";
		if (!address.country) newErrors[`${fieldPrefix}.country`] = "Country is required";
		if (!address.state) newErrors[`${fieldPrefix}.state`] = "State is required";

		setErrors((prevErrors) => ({ ...prevErrors, ...newErrors }));
		return Object.keys(newErrors).length === 0;
	};

	const validateAdditionalOrderDetails = () => {
		const { delivery_terms, ship_complete, mode_of_delivery } = checkoutDetails.additional_details;
		const newErrors = {};

		if (!delivery_terms) newErrors["additional_details.delivery_terms"] = "Delivery terms are required";
		if (!ship_complete) newErrors["additional_details.ship_complete"] = "Ship complete is required";
		if (!mode_of_delivery) newErrors["additional_details.mode_of_delivery"] = "Mode of delivery is required";

		setErrors((prevErrors) => ({ ...prevErrors, ...newErrors }));
		return Object.keys(newErrors).length === 0;
	};

	// const validatePaymentDetails = () => {
	// 	const { payment_mode, payment_details } = checkoutDetails.payment_details;
	// 	const newErrors = {};

	// 	// Check if files are uploaded or PO is provided
	// 	const isFileUploaded = uploadedFile.length > 0;

	// 	// If no file is uploaded and payment mode is "PO", validate PO number
	// 	if (payment_mode === "PO" && !isFileUploaded && !payment_details.po_number) {
	// 		newErrors["payment_details.payment_details.po_number"] = "PO number is required for PO payment mode";
	// 	}

	// 	setErrors((prevErrors) => ({ ...prevErrors, ...newErrors }));
	// 	return Object.keys(newErrors).length === 0;
	// };

	const validatePaymentDetails = () => {
		const { payment_mode, payment_details } = checkoutDetails.payment_details;
		const newErrors = {};

		// Check if files are uploaded
		const isFileUploaded = uploadedFile.length > 0;

		// If payment mode is "PO" and no file is uploaded, return false
		if (payment_mode === "PO") {
			if (!isFileUploaded) {
				newErrors["payment_details.payment_details.file"] = "File upload is required for PO payment mode";
			}
			if (!payment_details.po_number) {
				newErrors["payment_details.payment_details.po_number"] = "PO number is required for PO payment mode";
			}
		}

		setErrors((prevErrors) => ({ ...prevErrors, ...newErrors }));

		return Object.keys(newErrors).length === 0;
	};

	const handlePaymentModeChange = (event) => {
		const value = event.target.value;
		setCheckoutDetails((prev) => ({
			...prev,
			payment_details: {
				...prev.payment_details,
				payment_mode: value,
				payment_details: {
					...prev.payment_details.payment_details,
					po_number: value === "PO" ? prev.payment_details.payment_details.po_number : "",
				},
			},
		}));
	};

	const updateNestedField = (obj, keys, value) => {
		const [currentKey, ...remainingKeys] = keys;

		if (!remainingKeys.length) {
			return {
				...obj,
				[currentKey]: value,
			};
		}

		return {
			...obj,
			[currentKey]: updateNestedField(obj[currentKey] || {}, remainingKeys, value),
		};
	};

	const handleFieldChange = (section, field, value) => {
		setCheckoutDetails((prevDetails) => updateNestedField(prevDetails, [section, ...field.split(".")], value));
	};

	const handleCheckout = async () => {
		setButtonLoading(true);
		const selectedSiteDetails = siteData.filter((site) => site.customer_site_number === selectedSite);

		// Add base64 file conversion
		let base64File = "";
		let fileName = "";
		if (uploadedFile) {
			try {
				const fileInput = document.querySelector('input[type="file"]');
				const file = fileInput.files[0];
				fileName = file.name;
				const reader = new FileReader();
				base64File = await new Promise((resolve, reject) => {
					reader.onload = () => resolve(reader.result.split(",")[1]);
					reader.onerror = reject;
					reader.readAsDataURL(file);
				});
			} catch (error) {
				console.error("Error converting file to base64:", error);
				setButtonLoading(false);
				Swal.fire({
					icon: "error",
					title: "Error",
					text: "Error processing uploaded file. Please try again.",
				});
				return;
			}
		}

		if (cartProducts.some((i) => !i.Product.purchasable)) {
			setButtonLoading(false);
			Swal.fire({
				icon: "error",
				title: "Error",
				text: "Cannot Complete Checkout. Some items may not be purchasable",
			});
			return;
		}

		const isShippingValid = validateAddress(checkoutDetails.shipping_address, "shipping_address");
		const isBillingValid = validateAddress(checkoutDetails.billing_address, "billing_address");
		const areAdditionalDetailsValid = validateAdditionalOrderDetails();
		const arePaymentDetailsValid = validatePaymentDetails();

		if (
			!isShippingValid ||
			!isBillingValid ||
			!areAdditionalDetailsValid ||
			!arePaymentDetailsValid ||
			!termsAccepted
		) {
			setButtonLoading(false);
			Swal.fire({
				icon: "error",
				title: "Error",
				text: "Please fill in all required fields before proceeding.",
			});
			return;
		}

		const cart_products = cartProducts.map((item) => ({
			product_id: item.Product.product_id,
			product_name: item.Product.product_name,
			product_number: item.Product.product_number,
			product_lead_date: getLeadDate(item.Product),
			ProductQty: item.Quantity,
			ProductPrice:
				item.Product[`price_${selectedSiteCurrency}`] === "0"
					? item.Product.product_sell_price
					: item.Product[`price_${selectedSiteCurrency}`],
			total: (
				item.Quantity *
				parseFloat(
					item.Product[`price_${selectedSiteCurrency}`] === "0"
						? item.Product.product_sell_price
						: item.Product[`price_${selectedSiteCurrency}`]
				)
			).toFixed(2),
		}));

		console.log("Cart Products: ", cart_products);

		const productTotal = cart_products.reduce((total, item) => total + parseFloat(item.total), 0);
		// const taxes = (productTotal * 0.08).toFixed(2);
		// const discount = (productTotal * 0.05).toFixed(2);
		// const shipping = 50.0;
		const total = productTotal.toFixed(2);

		const newCheckoutDetails = {
			shipping_address: checkoutDetails.shipping_address,
			billing_address: checkoutDetails.billing_address,
			additional_details: checkoutDetails.additional_details,
			payment_details: {
				payment_mode: checkoutDetails.payment_details.payment_mode,
				payment_details: {
					po_number: checkoutDetails.payment_details.payment_details.po_number,
					po_file: base64File,
					po_filename: fileName,
				},
			},
			order_details: {
				products: cart_products,
				taxes: 0.0,
				shipping: 0.0,
				discounts: 0.0,
				total: total,
			},
			selectedSite: selectedSiteDetails[0].site_id,
			loggedin_user: user.user_id,
			loggedin_user_email: user.user_email,
			loggedin_user_name: user.user_first_name + " " + user.user_last_name,
			loggedin_user_phone: user.user_phone || "",
		};

		setCheckoutDetails(newCheckoutDetails);
		console.log("newCheckoutDetails", newCheckoutDetails);
		try {
			// Send the API request to place the order
			const response = await customHttp.post("/orders/create", newCheckoutDetails);

			// Handle success
			if (response.data && response.data.success) {
				clearCart();
				setButtonLoading(false);
				setButtonSuccess(true);
				setTimeout(() => {
					setButtonSuccess(false);
					navigate(`/quote-received/${response.data.order_key}`);
				}, 1000);
			} else {
				// Handle error if any
				setButtonLoading(false);
				console.error("Failed to place order: ", response.data.message);
				setError(response.data.message || "An error occurred while placing the order.");
			}
		} catch (error) {
			// Handle API call error
			setButtonLoading(false);
			console.error("Error while placing the order", error);
			setError("An error occurred while placing the order. Please try again.");
		}
	};

	const toggleEdit = (section) => {
		setIsEditing((prev) => ({
			...prev,
			[section]: !prev[section],
		}));
	};

	if (loading) {
		return (
			<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
				<CircularProgress />
			</Box>
		);
	}

	if (error && !loading) {
		return (
			<Alert severity="error" className="error-alert">
				{error}
			</Alert>
		);
	}

	return (
		<Box padding={2} width="100vw">
			<PageTitle title="Checkout"></PageTitle>
			<Box
				display="flex"
				justifyContent="space-between"
				gap="60px"
				alignItems="flex-start"
				flexDirection={isMobile ? "column" : "row"}
				margin="0 auto"
				marginTop="40px"
				sx={{ width: isMobile ? "100%" : "85%" }}>
				{/* Left Section */}
				<Box width={isMobile ? "100%" : "70%"} boxShadow="2" padding="5px" borderRadius="4px" marginBottom={2}>
					<Accordion sx={{ boxShadow: "none" }} onChange={handleAccordionChange("panel1")} defaultExpanded>
						<AccordionSummary expandIcon={<ExpandMoreIcon />}>
							<Typography
								variant="h6"
								sx={{ fontWeight: "bold" }}
								color={expandedPanels.panel1 ? "primary" : ""}>
								Shipping & Billing Address
							</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<Box
								display="flex"
								flexDirection={isMobile ? "column" : "row"}
								justifyContent="space-between"
								gap="20px">
								{/* Shipping Address Card */}
								<Card sx={{ width: isMobile ? "100%" : "48%" }}>
									<CardContent>
										<Box display="flex" justifyContent="space-between" alignItems="center">
											<Typography variant="h6" sx={{ fontWeight: "bold" }}>
												Shipping Address
											</Typography>
											{/* <IconButton
												onClick={() => toggleEdit("shipping")}
												color={isEditing.shipping ? "primary" : ""}>
												<EditIcon />
											</IconButton> */}
										</Box>
										{isEditing.shipping ? (
											<Box mt={2}>
												<TextField
													label="Name"
													size="small"
													fullWidth
													value={checkoutDetails.shipping_address.name}
													error={!!errors["shipping_address.name"]}
													onChange={(e) =>
														handleInputChange("shipping_address", "name", e.target.value)
													}
													sx={{ mb: 2 }}
												/>
												<TextField
													label="Street"
													size="small"
													fullWidth
													value={checkoutDetails.shipping_address.street}
													error={!!errors["shipping_address.street"]}
													onChange={(e) =>
														handleInputChange("shipping_address", "street", e.target.value)
													}
													sx={{ mb: 2 }}
												/>
												<TextField
													label="City"
													size="small"
													fullWidth
													value={checkoutDetails.shipping_address.city}
													error={!!errors["shipping_address.city"]}
													onChange={(e) =>
														handleInputChange("shipping_address", "city", e.target.value)
													}
													sx={{ mb: 2 }}
												/>
												<TextField
													label="State"
													size="small"
													fullWidth
													value={checkoutDetails.shipping_address.state}
													error={!!errors["shipping_address.state"]}
													onChange={(e) =>
														handleInputChange("shipping_address", "state", e.target.value)
													}
													sx={{ mb: 2 }}
												/>
												<TextField
													label="ZIP"
													size="small"
													fullWidth
													value={checkoutDetails.shipping_address.zip}
													error={!!errors["shipping_address.zip"]}
													onChange={(e) =>
														handleInputChange("shipping_address", "zip", e.target.value)
													}
													sx={{ mb: 2 }}
												/>
												<TextField
													label="Country"
													size="small"
													fullWidth
													value={checkoutDetails.shipping_address.country}
													error={!!errors["shipping_address.country"]}
													onChange={(e) =>
														handleInputChange("shipping_address", "country", e.target.value)
													}
													sx={{ mb: 2 }}
												/>
											</Box>
										) : (
											<Box mt={2}>
												<Typography variant="body1">
													{checkoutDetails.shipping_address.name}
												</Typography>
												<Typography variant="body1">
													{checkoutDetails.shipping_address.street}
												</Typography>
												<Typography variant="body1">
													{checkoutDetails.shipping_address.city}
												</Typography>
												<Typography variant="body1">
													{checkoutDetails.shipping_address.state}
												</Typography>
												<Typography variant="body1">
													{checkoutDetails.shipping_address.zip}
												</Typography>
												<Typography variant="body1">
													{checkoutDetails.shipping_address.country}
												</Typography>
											</Box>
										)}
									</CardContent>
								</Card>

								{/* Billing Address Card */}
								<Card sx={{ width: isMobile ? "100%" : "48%" }}>
									<CardContent>
										<Box display="flex" justifyContent="space-between" alignItems="center">
											<Typography variant="h6" sx={{ fontWeight: "bold" }}>
												Billing Address
											</Typography>
											{/* <IconButton
												onClick={() => toggleEdit("billing")}
												color={isEditing.billing ? "primary" : ""}>
												<EditIcon />
											</IconButton> */}
										</Box>
										{isEditing.billing ? (
											<Box mt={2}>
												<TextField
													label="Name"
													size="small"
													fullWidth
													value={checkoutDetails.billing_address.name}
													error={!!errors["billing_address.name"]}
													onChange={(e) =>
														handleInputChange("billing_address", "name", e.target.value)
													}
													sx={{ mb: 2 }}
												/>
												<TextField
													label="Street"
													size="small"
													fullWidth
													value={checkoutDetails.billing_address.street}
													error={!!errors["billing_address.street"]}
													onChange={(e) =>
														handleInputChange("billing_address", "street", e.target.value)
													}
													sx={{ mb: 2 }}
												/>
												<TextField
													label="City"
													size="small"
													fullWidth
													value={checkoutDetails.billing_address.city}
													error={!!errors["billing_address.city"]}
													onChange={(e) =>
														handleInputChange("billing_address", "city", e.target.value)
													}
													sx={{ mb: 2 }}
												/>
												<TextField
													label="State"
													size="small"
													fullWidth
													value={checkoutDetails.billing_address.state}
													error={!!errors["billing_address.state"]}
													onChange={(e) =>
														handleInputChange("billing_address", "state", e.target.value)
													}
													sx={{ mb: 2 }}
												/>
												<TextField
													label="ZIP"
													size="small"
													fullWidth
													value={checkoutDetails.billing_address.zip}
													error={!!errors["billing_address.zip"]}
													onChange={(e) =>
														handleInputChange("billing_address", "zip", e.target.value)
													}
													sx={{ mb: 2 }}
												/>
												<TextField
													label="Country"
													size="small"
													fullWidth
													value={checkoutDetails.billing_address.country}
													error={!!errors["billing_address.country"]}
													onChange={(e) =>
														handleInputChange("billing_address", "country", e.target.value)
													}
													sx={{ mb: 2 }}
												/>
											</Box>
										) : (
											<Box mt={2}>
												<Typography variant="body1">
													{checkoutDetails.billing_address.name}
												</Typography>
												<Typography variant="body1">
													{checkoutDetails.billing_address.street}
												</Typography>
												<Typography variant="body1">
													{checkoutDetails.billing_address.city}
												</Typography>
												<Typography variant="body1">
													{checkoutDetails.billing_address.state}
												</Typography>
												<Typography variant="body1">
													{checkoutDetails.billing_address.zip}
												</Typography>
												<Typography variant="body1">
													{checkoutDetails.billing_address.country}
												</Typography>
											</Box>
										)}
									</CardContent>
								</Card>
							</Box>
						</AccordionDetails>
					</Accordion>

					<Accordion sx={{ boxShadow: "none" }} onChange={handleAccordionChange("panel2")} defaultExpanded>
						<AccordionSummary expandIcon={<ExpandMoreIcon />}>
							<Typography
								variant="h6"
								sx={{ fontWeight: "bold" }}
								color={expandedPanels.panel2 ? "primary" : ""}>
								Additional Quote Details{" "}
							</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
								<Box sx={{ display: "flex", gap: 2 }}>
									{/* <FormControl fullWidth>
										<InputLabel>Delivery Terms</InputLabel>
										<Select
											size="small"
											value={checkoutDetails.additional_details.delivery_terms}
											error={!!errors["additional_details.delivery_terms"]}
											label="Delivery Terms"
											onChange={(e) =>
												handleFieldChange(
													"additional_details",
													"delivery_terms",
													e.target.value
												)
											}>
											<MenuItem value="Prepaid and Add">Prepaid and Add</MenuItem>
											<MenuItem value="Collect on Delivery">Collect on Delivery</MenuItem>
										</Select>
									</FormControl> */}
									<FormControl fullWidth>
										<InputLabel>
											Request Expedite Options{" "}
											<Tooltip
												title={
													"Our team will review expediting options and follow up for confirmation. EXPEDITING OPTIONS ARE SUBJECT TO AVAILABILITY AND NOT GUARANTEED."
												}
												placement="right"
												arrow>
												<HelpIcon
													sx={{
														fontSize: "15px",
														ml: 0.5,
														color: "#D3D3D3",
														"&:hover": { color: "#aaa" },
													}}
												/>
											</Tooltip>{" "}
										</InputLabel>
										<Select
											size="small"
											value={checkoutDetails.additional_details.ship_complete}
											error={!!errors["additional_details.ship_complete"]}
											label={
												<>
													Request Expedite Options
													<Tooltip
														title="Our team will review expediting options and follow up for confirmation. EXPEDITING OPTIONS ARE SUBJECT TO AVAILABILITY AND NOT GUARANTEED."
														placement="right"
														arrow>
														<HelpIcon
															sx={{
																fontSize: "15px",
																ml: 0.5,
																color: "#D3D3D3",
																"&:hover": { color: "#aaa" },
															}}
														/>
													</Tooltip>
												</>
											}
											onChange={(e) => {
												if (e.target.value === "Yes") {
													setMessageShow(true);
													console.log(e.target.value);
												} else {
													setMessageShow(false);
												}
												handleFieldChange(
													"additional_details",
													"ship_complete",
													e.target.value
												);
											}}>
											<MenuItem value="Yes">Yes</MenuItem>
											<MenuItem value="No">No</MenuItem>
										</Select>
									</FormControl>
								</Box>

								{messageShow && (
									<Typography variant="body1" sx={{ fontSize: "11px" }}>
										<b>Please Note</b> Expediting options are subject to availability and are not
										guaranteed.
									</Typography>
								)}
								{/* <Box sx={{ display: "flex", gap: 2 }}>
									<FormControl fullWidth>
										<InputLabel>Mode of Delivery</InputLabel>
										<Select
											size="small"
											value={checkoutDetails.additional_details.mode_of_delivery}
											error={!!errors["additional_details.mode_of_delivery"]}
											label="Mode of Delivery"
											onChange={(e) =>
												handleFieldChange(
													"additional_details",
													"mode_of_delivery",
													e.target.value
												)
											}>
											<MenuItem value="UPS Ground">UPS Ground</MenuItem>
											<MenuItem value="UPS Next Day Air">UPS Next Day Air</MenuItem>
											<MenuItem value="FedEx Ground">FedEx Ground</MenuItem>
										</Select>
									</FormControl>
									<TextField
										fullWidth
										size="small"
										label="Freight Number"
										value={checkoutDetails.additional_details.freight_number}
										onChange={(e) =>
											handleFieldChange("additional_details", "freight_number", e.target.value)
										}
										placeholder="Enter Freight Number"
									/>
								</Box> */}

								<TextField
									fullWidth
									size="small"
									label="Order Notes"
									multiline
									rows={4}
									value={checkoutDetails.additional_details.order_notes}
									onChange={(e) =>
										handleFieldChange("additional_details", "order_notes", e.target.value)
									}
									placeholder="Enter Order Notes"
								/>
							</Box>
						</AccordionDetails>
					</Accordion>

					<Accordion sx={{ boxShadow: "none" }} onChange={handleAccordionChange("panel3")} defaultExpanded>
						<AccordionSummary expandIcon={<ExpandMoreIcon />}>
							<Typography
								variant="h6"
								sx={{ fontWeight: "bold" }}
								color={expandedPanels.panel3 ? "primary" : ""}>
								Payment Details
							</Typography>
							<Typography variant="caption" ml={1} fontSize={"18px"} color="error">
								*
							</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<Box
								sx={{
									display: "flex",
									flexDirection: "column",
									gap: 2,
									marginTop: "8px",
								}}>
								{/* First row */}
								<Box sx={{ display: "flex", gap: 2 }}>
									<FormControl fullWidth>
										<InputLabel>
											<>
												Payment Method{" "}
												<Typography component="span" variant="caption" color="error">
													*
												</Typography>
											</>
										</InputLabel>
										<Select
											size="small"
											value={checkoutDetails.payment_details.payment_mode}
											onChange={handlePaymentModeChange}
											label="Payment Method *"
											sx={{ width: "50%" }}>
											<MenuItem value="PO">PO</MenuItem>
											{/* <MenuItem value="CC">Credit / Debit Cards</MenuItem> */}
										</Select>
									</FormControl>
								</Box>

								<Box sx={{ display: "flex", gap: 2 }}>
									{checkoutDetails.payment_details.payment_mode === "PO" && (
										<FormControl>
											<TextField
												fullWidth
												size="small"
												label={
													<>
														PO Number{" "}
														<Typography component="span" variant="caption" color="error">
															*
														</Typography>
													</>
												}
												value={checkoutDetails.payment_details.payment_details.po_number}
												error={
													!!errors["payment_details.payment_details.po_number"] &&
													uploadedFile.length === 0
												}
												onChange={(e) =>
													handleFieldChange(
														"payment_details",
														"payment_details.po_number",
														e.target.value
													)
												}
											/>
										</FormControl>
									)}
									<FormControl>
										<IconButton
											component="label"
											variant="contained"
											// color="primary"
											color={
												checkoutDetails.payment_details.payment_mode === "PO" && !uploadedFile
													? "error"
													: "primary"
											}
											sx={{
												display:
													checkoutDetails.payment_details.payment_mode === "PO"
														? "inline-block"
														: "none",
											}}>
											<CloudUploadIcon
												color={
													errors["payment_details.payment_details.file"] ? "error" : "primary"
												}
											/>
											<input type="file" onChange={handleFileUpload} hidden />
										</IconButton>
										{uploadedFile && checkoutDetails.payment_details.payment_mode === "PO" && (
											<Typography variant="body2" color="textSecondary">
												{uploadedFile}
											</Typography>
										)}
									</FormControl>
								</Box>
							</Box>
						</AccordionDetails>
					</Accordion>
				</Box>

				{/* Order Summary */}
				<Box width={isMobile ? "100%" : "30%"} sx={{ position: "sticky", top: "100px" }}>
					<Card>
						<CardContent>
							<Typography variant="h6" fontWeight="bold" marginBottom="10px">
								QUOTE SUMMARY
							</Typography>
							<Box sx={{ maxHeight: 200, overflowY: "auto" }}>
								<TableContainer>
									<Table>
										<TableHead>
											<TableRow>
												<TableCell>Part</TableCell>
												<TableCell>Qty</TableCell>
												<TableCell>Price</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{/* Dynamically render products */}
											{cartProducts.map((product, index) => (
												<TableRow key={index}>
													<TableCell>{product.Product.product_name}</TableCell>
													<TableCell>{product.Quantity}</TableCell>
													<TableCell>
														{currencySymbol}
														{product.Product[`price_${selectedSiteCurrency}`] === "0"
															? product.Product.product_sell_price
															: product.Product[`price_${selectedSiteCurrency}`]}
													</TableCell>
												</TableRow>
											))}

											{/* Total Row */}
											<TableRow>
												<TableCell colSpan={2} align="right" fontWeight="bold">
													Total
												</TableCell>
												<TableCell fontWeight="bold">
													{currencySymbol}
													{cartProducts
														.reduce(
															(total, product) =>
																total +
																parseFloat(
																	product.Product[`price_${selectedSiteCurrency}`] ===
																		"0"
																		? product.Product.product_sell_price
																		: product.Product[
																				`price_${selectedSiteCurrency}`
																		  ]
																).toFixed(2) *
																	product.Quantity,
															0
														)
														.toFixed(2)}
												</TableCell>
											</TableRow>
										</TableBody>
									</Table>
								</TableContainer>
							</Box>

							<Typography marginTop="25px">
								Your personal data will be used to process your order, support your experience
								throughout this website, and for other purposes described in our{" "}
								<Link
									href={`${ASSETS_BASE_URL}/Legal/Privacy Policy.pdf`}
									target="_blank"
									color="primary">
									privacy policy
								</Link>
								.
							</Typography>

							<FormControlLabel
								sx={{ mt: 2 }}
								control={
									<Checkbox color="primary" checked={termsAccepted} onChange={handleCheckboxChange} />
								}
								label={
									<>
										Accept{" "}
										<Link
											href={`${ASSETS_BASE_URL}/Legal/Terms and Conditions.pdf`}
											target="_blank"
											color="primary">
											Terms and Conditions
										</Link>
									</>
								}
							/>

							{/* Place Order Button */}
							<Button
								variant="contained"
								color="primary"
								fullWidth
								sx={{ mt: 2 }}
								disabled={!termsAccepted || user.user_role === "Viewer"}
								onClick={handleCheckout}>
								{buttonLoading ? (
									<>Requesting for Quote</>
								) : buttonSuccess ? (
									<>
										<CheckCircleIcon sx={{ color: "white", marginRight: 1 }} />
										Request Sent
									</>
								) : (
									"Request for Quote"
								)}
							</Button>

							{user.user_role === "Viewer" && (
								<Typography variant="body1" color="error" sx={{ mt: 1 }}>
									You are not authorized to place an order. <br />
									Please contact the customer care for further details
								</Typography>
							)}

							<Typography variant="body1" sx={{ fontSize: "11px", marginTop: "10px" }}>
								Note: Our default shipping is UPS ground, PP&A, UNLESS OTHERWISE SPECIFIED. Shipping
								fees & Taxes will be added to the invoice.
							</Typography>
						</CardContent>
					</Card>
				</Box>
			</Box>
			{(buttonLoading || buttonSuccess) && <DefaultLoader />}
		</Box>
	);
};

export default Checkout;
